import {msalInstance} from "../security/AuthProvider";

export const isAdmin = () => {
    const account = msalInstance.getActiveAccount();
	return account && account.idTokenClaims.roles.filter(x => x == 'Admin').length > 0;
}